import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getStorageToken, removeStorageToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
	baseURL: window.config.VUE_APP_API, // url = base url + request url
	withCredentials: true, // send cookies when cross-domain requests
	timeout: -1 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		if(getStorageToken()) {
			config.headers['token'] = getStorageToken()
		}
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data;
		if(res.code && res.code == "UNAUTHENTICATED") {
			store.dispatch('user/openLogin', {
				loging: true
			})
		}
		if(res.code && res.code == "USER_LOCKED_ERROR") {
			store.dispatch('user/openLogin', {
				loging: true
			})
		}
		if(res.code && res.code == "UNAUTHORIZED") {
			MessageBox.alert('当前用户无权限！', '提示', {
				confirmButtonText: '确定',
				type: 'warning'
			}).then(() => {}).catch(() => {})
		}
		return res
	},
	error => {
		return Promise.reject(error)
	}
)

export default service